var _line, _polyline, _polyline2, _polyline3, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharacterCardBorderTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-413de5a2-6650-4592-b835-84c8e743093d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524.20931 17.95141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 15.95141,
    x2: 524.20931,
    y2: 15.95141,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "275.22305 15.68691 260.95035 1.41421 246.67765 15.68691",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "255.10745 7.22281 143.29035 7.22281 134.97315 15.53991",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "266.17125 7.22281 378.61035 7.22281 386.92745 15.53991",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 370.29315,
    y1: 7.22281,
    x2: 378.61035,
    y2: 15.53991,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 151.60745,
    y1: 7.22281,
    x2: 143.29035,
    y2: 15.53991,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterCardBorderTop);
export default __webpack_public_path__ + "static/media/character-card-border-top.0763b183b14e179ef449cbfa4c8fdd57.svg";
export { ForwardRef as ReactComponent };